<template>
  <div class="reclaim-email">
    <h1>Reclaim Email</h1>
    <div class="reclaim-email-form">
      <div class="form-elements">
        <UiSelect
          disable-filter
          has-search
          label="Search by Email"
          :loading="emailSearchLoading"
          :no-results="emailNoResults"
          :options="emailOptions"
          @query-change="onEmailChange"
          :keys="{ label: 'email' }"
          v-model="user"
        >
          <template slot-scope="props" slot="option">
            <div>
              <strong>{{ props.option.email }}</strong>
              <span>{{ props.option.first_name }} {{ props.option.last_name }}</span>
              <div v-if="props.option.org_name">
                Currently at: <em>{{props.option.org_name}}</em>
              </div>
              <div v-if="props.option.last_visit">
                Last visit: <em>{{ relativeTime(props.option.last_visit) }}</em>
              </div>
            </div>
          </template>
        </UiSelect>
        <UiTextbox
          v-model="newEmail"
          label="New Email for this User"
        />
        <UiButton
          :loading="loading"
          raised
          @click="reclaimEmail"
        >
          Reassign
        </UiButton>
        <div class="message">{{ message }}</div>
        <div class="error">{{ error }}</div>
      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { UiSelect, UiButton, UiTextbox } from 'keen-ui';
import { sleep } from '@/utils';
import { searchUsersByEmail, changeEmail } from '@/store/modules/api';

export default {
  name: 'ReclaimEmail',
  data() {
    return {
      emailSearchLoading: null,
      emailSearchError: null,
      emailOptions: [],
      newEmail: null,
      user: null,
      query: null,
      message: null,
      error: null,
      loading: null,
    };
  },
  computed: {
    emailNoResults() {
      return !this.emailSearchLoading && this.query && this.emailOptions.length === 0;
    },
  },
  methods: {
    relativeTime(ts) {
      return moment(ts).fromNow();
    },
    onEmailChange(query) {
      this.query = query;
      if (query.length === 0) return;
      this.emailSearchLoading = true;
      this.searchUser(query);
    },
    searchUser: _.debounce(async function searchUser(query) {
      this.emailSearchError = null;
      try {
        const { users } = await searchUsersByEmail(query);
        this.emailOptions = users;
      } catch (e) {
        this.emailSearchError = e;
      }
      this.emailSearchLoading = false;
    }, 500),
    async reclaimEmail() {
      if (!this.user && this.newEmail) {
        this.error = 'please fill out the form first';
        return;
      }
      this.loading = true;
      this.error = null;
      try {
        const { message } = await changeEmail(this.user.id, this.newEmail);
        this.message = message;
        this.loading = false;
        await sleep(8000);
        this.message = null;
      } catch (e) {
        this.error = e;
        this.loading = false;
      }
    },
  },
  components: {
    UiSelect, UiButton, UiTextbox,
  },
};
</script>

<style lang="scss">
.reclaim-email {
  .reclaim-email-form {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    margin-bottom: 30px;
    &:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }
    width: 100%;
    width: fit-content;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding: 2px 16px;
    > * {
      display: inline-block;
      margin: 10px 20px;
      width: 300px;
    }

    .error {
      color: red;
    }
    .success {
      color: green;
    }
    .ui-textbox, .ui-select {
      max-width: 350px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReclaimEmail.vue